import { CLEAN_REDUCER, CLEAR_SESSION } from '../../constants/actionTypes';
import { FETCH_COMMISSION_COUNT, FETCH_COMMISSIONS } from './actionTypes';

const initState = {
	commissions: [],
	count: 0,
};

const reducer = (state = initState, action) => {
	switch (action.type) {
		case FETCH_COMMISSIONS:
			return {
				...state,
				commissions: action.commissions,
			};
		case FETCH_COMMISSION_COUNT:
			return {
				...state,
				count: action.count,
			};
		case CLEAN_REDUCER:
			return initState;
		case CLEAR_SESSION:
			return initState;
		default:
			return state;
	}
};

export default reducer;
